module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_3_LV-9198a9a756b3cd793590e25777712cf8.svg";